// extracted by mini-css-extract-plugin
export default {"heading-1":"heading_heading-1__Nyxfp","heading-2":"heading_heading-2__Z4OPv","heading-3":"heading_heading-3__72sA9","heading-4":"heading_heading-4__yFsXX"};